import api from "./api";
import {axiosInstance} from "./axiosInstance";
import store from "../store/index";

/**
 * Add item to the users cart
 * @param {String} itemID
 * @param {String} variantID
 * @param {Number} qty
 * @param {Array} dimensionObjects
 * @param {Array} options
 */
export async function addItemToCart({
  itemID,
  variantID,
  qty,
  dimensionObjects,
  options,
}) {
  const requestData = await api.post(
    "/api/v1/cartitem",
    {
      ItemID: itemID.toString(),
      VariantID: variantID,
      Qty: qty,
      DimensionObjectID: dimensionObjects,
      ...options,
    },
    {
      params: {
        customerID: store.state.customerID ?? null,
      },
    },
  );

  return requestData.data;
}

export async function patchCartItem({cartItem}) {
  if (cartItem.person && cartItem.person !== null && cartItem.person !== "") {
    const personObject = store.getters.persons.filter(
      (person) => person.name === cartItem.person,
    )[0];

    cartItem.dimensionObjectID = personObject?.dimensionObjectID;
    delete cartItem.person;
  }

  if (cartItem.options) {
    delete cartItem.options;
  }

  const requestData = await api.patch(
    `/api/v1/cartitem/${cartItem.cartItemID}`,
    cartItem,
    {
      params: {
        customerID: store.state.customerID ?? null,
      },
    },
  );
  return requestData.data;
}

export async function deleteCartItem({cartItemID}) {
  const requestData = await api.delete(`/api/v1/cartitem/${cartItemID}`, {
    params: {
      customerID: store.state.customerID ?? null,
    },
  });
  return requestData;
}

export async function getCart() {
  const requestData = await api.get("/api/v1/cart", {
    params: {
      customerID: store.state.customerID ?? null,
    },
  });

  return requestData.data;
}

export async function getCartPrices() {
  const requestData = await api.get("/api/v1/cart/price", {
    params: {
      customerID: store.state.customerID ?? null,
    },
  });

  return requestData.data;
}

export async function getCartItemAttachments({cartItemID}) {
  const requestData = await api.get(`/api/v1/cartitem/CartItemAttachments`, {
    params: {
      cartItemID,
      customerID: store.state.customerID ?? null,
    },
  });

  return requestData.data;
}

export async function deleteCartItemAttachments({cartItemID}) {
  const requestData = await api.delete(`/api/v1/cartitem/DeleteAttachments`, {
    params: {
      cartItemID,
      customerID: store.state.customerID ?? null,
    },
  });

  return requestData.data;
}

export async function uploadFileToCartItem({cartItem, formData}) {
  const requestData = await axiosInstance.post(
    `/api/v1/cartitem/${cartItem.cartItemID}/attachment`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      params: {
        customerID: store.state.customerID ?? null,
      },
    },
  );
  return requestData.data;
}

export async function setTransportOption({transportID, countryID}) {
  const result = await api.patch(
    `/api/v1/cart/transport`,
    {},
    {
      params: {
        countryID,
        transportID,
        customerID: store.state.customerID ?? null,
      },
    },
  );

  return result.data;
}

export async function createOrder({orderInformation} = {}) {
  const requestData = await api.post(
    "/api/v1/cart/checkout",
    {
      ...orderInformation,
    },
    {
      params: {
        customerID: store.state.customerID ?? null,
      },
    },
  );

  return requestData;
}

export async function applyActionCode({actionCode}) {
  const result = await api.post(
    `/api/v1/cart/actioncode/${actionCode}`,
    {},
    {
      params: {
        customerID: store.getters.customerID,
      },
    },
  );

  return result.data;
}

export async function removeActionCode({actionCode}) {
  const result = await api.delete(`/api/v1/cart/actioncode/${actionCode}`, {
    params: {
      customerID: store.getters.customerID,
    },
  });

  return result.data;
}
